import baseDataProvider from './baseDataProvider'
import { dataProvider as centersDataProvider } from '../centers/dataProvider'
import { dataProvider as eventsDataProvider } from '../events/dataProvider'
import { dataProvider as leadsDataProvider } from '../leads/dataProvider'
import { dataProvider as profilesDataProvider } from '../profiles/dataProvider'
import { dataProvider as schoolsDataProvider } from '../schools/dataProvider'
import { dataProvider as rendezvousDataProvider } from '../rendezvous/dataProvider'
import { dataProvider as tasksDataProvider } from '../tasks/dataProvider'
import { dataProvider as inboundContactsDataProvider } from '../inboundContacts/dataProvider'
import { dataProvider as parcoursupDataProvider } from '../parcoursup/dataProvider'

const dataProvidersByResource = {
  'centers': centersDataProvider,
  'events': eventsDataProvider,
  'leads': leadsDataProvider,
  'profiles': profilesDataProvider,
  'schools': schoolsDataProvider,
  'schools_view': schoolsDataProvider,
  'rendezvous': rendezvousDataProvider,
  'tasks': tasksDataProvider,
  'inbound_contacts': inboundContactsDataProvider,
  'leads_parcoursup': parcoursupDataProvider,
  'parcoursup_voeux': parcoursupDataProvider,
  'parcoursup_evolution': parcoursupDataProvider,
  'parcoursup_historique': parcoursupDataProvider,
  'parcoursup_settings': parcoursupDataProvider,
}

// Collect custom (non-CRUD) methods from resource-specific providers
// so they can be called without a resource string: dataProvider.myMethod(params)
const customMethods = {}
const seenProviders = new Set()
Object.values(dataProvidersByResource).forEach(dp => {
  if ( seenProviders.has(dp) ) return
  seenProviders.add(dp)
  Object.keys(dp).forEach(key => {
    if ( typeof dp[key] === 'function' && !baseDataProvider[key] ) {
      customMethods[key] = dp[key].bind(dp)
    }
  })
})

const defaultHandler = {
  get: (target, property) => {
    // Custom methods (not in base): called as dataProvider.method(params)
    if ( customMethods[property] ) {
      return customMethods[property]
    }

    // Standard CRUD: called as dataProvider.method(resource, params)
    return (resource, params) => {
      const dataProvider = dataProvidersByResource[resource] || baseDataProvider
      const method = dataProvider[property]

      if (!method) {
        throw new Error(`Unknown dataProvider function: ${property}`)
      }

      return method.call(dataProvider, resource, params)
    }
  }
}

const dataProvider = new Proxy({}, defaultHandler)

export default dataProvider